import React, { Component } from 'react';
import { connect } from 'react-redux';
import View from './view';
import { Loader } from 'common';
import { Box, Typography, Grid, Divider } from '@material-ui/core';
import Anchor from 'antd/es/anchor';
import { createJob, getJobById } from 'controllers/job';
import '../create/create.scss';

const { Link } = Anchor;

class ViewJobContainer extends Component {
  constructor() {
    super();
    this.state = {
      loading: false,
    };
  }

  componentDidMount() {
    const {
      match: {
        params: { id },
      },
    } = this.props;

    if (id) {
      this.fetchJob(id);
    }
  }

  fetchJob = async (id) => {
    this.setState({
      loading: true,
    });
    await getJobById(id);
    this.setState({
      loading: false,
    });
  };

  onCreateJob = async () => {
    this.setState({
      loading: true,
    });
    await createJob();
    this.setState({
      loading: false,
    });
  };

  changeLocation = (location) => () => {
    const { history } = this.props;
    history.push(location);
  };

  render() {
    const { companyDetails } = this.props;
    const { loading } = this.state;

    if (loading) {
      return <Loader />;
    }

    return (
      <Grid container spacing={3} className="wrapper" justify="center">
        <Grid item xs={12}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Box p="18px">
                <Typography variant="h5">Job details</Typography>
              </Box>
              <Divider />
            </Grid>
            <Grid item xs={3}>
              <Anchor>
                <Link href="#the-job" title="The Job" />
                <Link href="#qualification" title="Qualification" />
                <Link href="#budget" title="Budget" />
                <Link href="#about-company" title="About company" />
              </Anchor>
            </Grid>
            <View
              companyDetails={companyDetails}
              changeLocation={this.changeLocation}
            />
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => ({
  companyDetails: state.user.details.organizationInfo,
});

export default connect(mapStateToProps, null)(ViewJobContainer);
